/**
 * Theme MKF2015 - Default Theme
 *
 * Migrado de themes/mkf2015/config/main.php
 * Este é o theme padrão do TMF.
 *
 * @since 2025-12-16
 * @epic INIT-0045-03, INIT-0046
 */

import type { Theme } from '../types';

export const mkf2015Theme: Theme = {
  name: 'MKF 2015',
  id: 'mkf2015',

  background: {
    color: '#f3f4f6', // gray-100 - cinza claro para light mode
    colorDark: '#111827', // gray-900 - escuro para dark mode
    image: '',
    imageDark: '',
    loginImage: '',
    loginImageDark: '',
    loginColor: '',
    loginColorDark: '',
  },

  colors: {
    link: '#205271',
    linkHover: '#102a3b',
    dialog: '#2a4d62',
    emailLink: '#fff',
    emailLinkDark: '',
    h1: '#205271',
    h2: '#205271',
    footerText: '#6b7280',
    footerTextDark: '',
    footerBackground: '#ffffff',
    footerBackgroundDark: '',
    footerBorder: '#e5e7eb',
    footerBorderDark: '',
    // Shell colors light mode — gray-100 sidebar e topbar branco com borda
    // sutil para reduzir brilho do light mode. Tenants que customizam shell
    // colors sobrescrevem estes valores. [TMF9-53595]
    sidebarBackground: '#f3f4f6',     // gray-100
    sidebarBackgroundDark: '#171717', // neutral-900 — alinhado com DARK_PALETTE.sidebar
    topbarBackground: '#ffffff',      // white com borda sutil
    topbarBackgroundDark: '#1f1f1f', // cinza neutro — alinhado com DARK_PALETTE.topbar
    topbarText: '#1f2937',            // gray-800 (legível em topbar branco)
    topbarTextDark: '#f5f5f5',        // neutral-100 — legível em topbar escuro
    topbarBorder: '#e5e7eb',          // gray-200
    topbarBorderDark: '#333333',      // cinza neutro — alinhado com DARK_PALETTE.border
  },

  blocks: {
    // Cores alternadas para blocos do dashboard (padrão TMF)
    // block1: Azul (cor primária) - índices pares (0, 2, 4...)
    // block2: Laranja (cor secundária) - índices ímpares (1, 3, 5...)
    // NOTA: Essas cores são sobrescritas pelas cores da API do tema
    block1: {
      background: '#18344f',  // Azul escuro TMF (da API)
      text: '#fff',
    },
    block2: {
      background: '#e35b00',  // Laranja TMF (da API)
      text: '#fff',
    },
  },

  buttons: {
    danger: {
      text: '#fff',
      background: '#d43f3a',
      backgroundHover: '#ba3732',
    },
    info: {
      text: '#fff',
      background: '#46b8da',
      backgroundHover: '#3da1bf',
    },
    secondary: {
      text: '#fff',
      background: '#547d95',
      backgroundHover: '#45677a',
    },
    success: {
      text: '#fff',
      background: '#62c462',
      backgroundHover: '#55ab55',
    },
    warning: {
      text: '#fff',
      background: '#f0ad4e',
      backgroundHover: '#d69a45',
    },
    primary: {
      text: '#fff',
      background: '#0074ba',
      backgroundHover: '#005a91',
    },
  },

  menus: {
    // Menu light mode (gray-100 sidebar com texto gray-700/800) [TMF9-53595]
    // Item ativo permanece laranja TMF (#e35b00). Hover usa gray-200 para
    // contraste sutil. NOTA: tenants que customizam o tema sobrescrevem estes
    // valores — estes são apenas fallbacks da identidade default mkf2015.
    main: {
      background: '#f3f4f6',       // gray-100
      text: '#374151',             // gray-700
      border: 'rgba(156,163,175,0.4)',
      activeBackground: '#e35b00', // laranja TMF (mantido)
      activeText: '#ffffff',
      hoverBackground: '#e5e7eb',  // gray-200
      hoverText: '#1f2937',        // gray-800
    },
    submenu: {
      background: '#f3f4f6',       // gray-100 (alinhado com main)
      text: '#4b5563',             // gray-600
      border: '#d1d5db',           // gray-300
      activeBackground: '#e35b00', // laranja TMF (consistente com main)
      activeText: '#ffffff',
      hoverBackground: '#e5e7eb',  // gray-200
      hoverText: '#1f2937',        // gray-800
    },
  },

  logos: {
    principal: 'https://static.trademarketingforce.com.br/dist/images/logos/mkf_logo.png',
    principalDark: '',
    menu: 'https://static.trademarketingforce.com.br/dist/images/logos/mkf_menu.jpg',
    menuDark: '',
    campanha: 'https://static.trademarketingforce.com.br/dist/images/backgrounds/logo_campanha.png',
    campanhaDark: '',
    loading: '',
    loadingDark: '',
  },

  icons: {
    appleTouch60: 'https://static.trademarketingforce.com.br/dist/images/icons/apple-touch-60.png',
    appleTouch76: 'https://static.trademarketingforce.com.br/dist/images/icons/apple-touch-76.png',
    appleTouch120: 'https://static.trademarketingforce.com.br/dist/images/icons/apple-touch-120.png',
    appleTouch152: 'https://static.trademarketingforce.com.br/dist/images/icons/apple-touch-152.png',
    favicon: 'https://static.trademarketingforce.com.br/dist/images/icons/favicon.ico',
    faviconDark: '',
  },
};

export default mkf2015Theme;
